/* 自定义校验规则
const resultMsg = {
  result: false,
  message: ''
}
*/
// 日访问量验证
export function validateIp(rule, value, callback) {
  // const reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/
  const reg = /^[0-9]+$/
  if (value == '' || value == null || value == undefined) {
    callback(new Error('必填不能为空'))
  } else if (!reg.test(value)) {
    callback(new Error('格式不正确'))
  } else if (value > 999999999) {
    callback(new Error('最大值不能超过999999999'))
  } else {
    callback()
  }
}

/* 验证5位正整数*/
export function validateNum5(rule, value, callback) {
  const reg = /^[1-9]\d*$|^[1-9]\d*\.\d\d?$|^0\.\d\d?$/
  if (!value) {
    callback(new Error('请输入价格'))
  } else if (!reg.test(value)) {
    callback(new Error('价格不能小于0'))
  } else if (value <= 0 || value >= 9999) {
    callback(new Error('必须是大于0小于9999的值'))
  } else {
    callback()
  }
}
/* 验证5位正整数*/
export function validateInteger5(rule, value, callback) {
  const reg = /^[1-9]\d{0,3}$/
  if (!reg.test(value)) {
    callback(new Error('必须是大于0小于9999的整数值'))
  } else {
    callback()
  }
}
export function validateNumF(rule, value, callback) {
  const reg = /^[1-9]\d*$|^[1-9]\d*\.\d\d?$|^0\.\d\d?$/
  if (!reg.test(value)) {
    callback(new Error('价格不能小于0'))
  } else if (value <= 0 || value >= 9999) {
    callback(new Error('必须是大于0小于9999的值'))
  } else {
    callback()
  }
}

/* 验证不超出40个字符*/
export function validateStr40(rule, value, callback) {
  const reg = /^(?=[\S\s]{1,40}$)[\S\s]*$/
  if (!value) {
    callback(new Error('请输入广告名称'))
  } else if (!reg.test(value)) {
    callback(new Error('最多40个字符'))
  } else {
    callback()
  }
}
/* 验证不超出30个字符*/
export function validateStr30(rule, value, callback) {
  const reg = /^(?=[\S\s]{1,30}$)[\S\s]*$/
  if (!value) {
    callback(new Error('请输入名称'))
  } else if (!reg.test(value)) {
    callback(new Error('最多30个字符'))
  } else {
    callback()
  }
}
/* 验证不超出2个字符*/
export function validateStr2(rule, value, callback) {
  if (!value) {
    callback(new Error('请输入计划名称'))
  } else if (value.length < 2) {
    callback(new Error('计划名称不得小于2位'))
  } else {
    callback()
  }
}
/* 验证手机号码*/
export function validateStrPhone(rule, value, callback) {
  const myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/
  var reg = /^([0-9]{3,4}-)?[0-9]{7,8}$/
  if (value == '' || value == null || value == undefined) {
    callback(new Error('必填项不能为空'))
  } else if (value && value.length && !myreg.test(value) && !reg.test(value)) {
    callback(new Error('号码格式不对'))
  } else {
    callback()
  }
}
/* 验证固定电话*/
export function validateStrPhoneMgd(rule, value, callback) {
  const myreg = /(^[0-9]{3,4}\-[0-9]{7}$)|(^[0-9]{7}$)|([0-9]{7}$)|(^[0-9]{7}$)）}/
  if (value && value.length && !myreg.test(value)) {
    callback(new Error('座机号码格式不对'))
  } else {
    callback()
  }
}
/* 验证姓名*/
export function validateName(rule, value, callback) {
  const reg = /^[\u4E00-\uFA29a-zA-Z]+$/
  if (value.length === 0) {
    callback(new Error('汇款人姓名不能为空'))
  } else if (value.length < 2) {
    callback(new Error('汇款人姓名不能少于2位'))
  } else if (value.length > 20) {
    callback(new Error('汇款人姓名不能多于20位'))
  } else if (!reg.test(value)) {
    callback(new Error('汇款人姓名只能输入中文或英文'))
  } else {
    callback()
  }
}
/* 验证输入金额*/
export function validateMoney(rule, value, callback) {
  const reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
  if (value === '') {
    callback(new Error('金额不能为空'))
  } else if (!reg.test(value)) {
    callback(new Error('请输入正确的包含两位小数的金额'))
  } else if (value * 1 <= 0) {
    callback(new Error('金额必须大于0'))
  } else if (value * 1 >= 99999999) {
    callback(new Error('金额必须小于99999999'))
  } else {
    callback()
  }
}
// 可退金额
export function validateMoneyNum(rule, value, callback) {
  // const myreg = parseFloat(value)
  if (value <= 0) {
    callback(new Error('退款金额必须大于0'))
  } else {
    callback()
  }
}
// 价格
export function validatePrice(rule, value, callback) {
  const reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
  if (value === '') {
    callback()
  } else if (!reg.test(value)) {
    callback(new Error('请输入正确的包含两位小数的单价'))
  } else if (value * 1 > 99999999) {
    callback(new Error('单价必须小于99999999'))
  } else {
    callback()
  }
}
// pv控制  正整数
export function validatePv(rule, value, callback) {
  const reg = /^\+?[1-9][0-9]*$/
  if (value === '') {
    callback()
  } else if (!reg.test(value)) {
    callback(new Error('请输入正整数'))
  } else {
    callback()
  }
}
// pv-end控制
export function validatePvEnd(rule, value, callback) {
  const reg = /^\+?[1-9][0-9]*$/
  if (value === '') {
    callback()
  } else if (!reg.test(value)) {
    callback(new Error('请输入正整数'))
  } else {
    callback()
  }
}
// 公司名称校验
export function validateCompany(rule, value, callback) {
  const reg = /^[\u4E00-\uFA29a-zA-Z]+$/
  if (value.length < 2) {
    return '公司名称不能少于2位'
  } else if (value.length > 24) {
    callback(new Error('公司名称不能多于24位'))
  } else if (!reg.exec(value)) {
    callback(new Error('公司名称只能输入中文或英文'))
  } else {
    callback()
  }
}
// 自定义域名验证
export function validateDomain(rule, value, callback) {
  var reg = /^(([a-zA-Z0-9][-a-zA-Z0-9]{0,62}|\*)+(\.[a-zA-Z0-9]{0,6}))+$/

  if (value == '' || value == null || value == undefined) {
    callback(new Error('必填不能为空'))
  } else if (!reg.exec(value)) {
    callback(new Error('网站域名格式错误'))
  } else if (!reg.exec(value)) {
    callback(new Error('网站域名长度不能大于100'))
  } else {
    callback()
  }
}
// 扣量比例验证
export function validateScale(rule, value, callback) {
  var reg = /^0\.[1-9]{0,2}$/
  if (!reg.test(value)) {
    callback(new Error('请输入0-1之间的小数，保留小数点后两位'))
  } else {
    callback()
  }
}

// 列表id搜索验证
export function idFilters(_val) {
  var re = /^[0-9]+$/
  if ((re.test(_val) || _val === '') && _val.length < 7) {
    return true
  } else {
    return false
  }
}
// 域名Id搜索验证
export function domainIdFilters(_val) {
  var re = /^[\-|0-9][0-9]*/
  if ((re.test(_val) || _val === '') && _val.length < 7) {
    return true
  } else {
    return false
  }
}
// 域名搜索验证
export function domainFilters(_val) {
  var reg = /^(([a-zA-Z0-9][-a-zA-Z0-9]{0,62}|\*)+(\.[a-zA-Z0-9]{0,6}))+$/
  if (reg.test(_val)) {
    return true
  } else {
    return false
  }
}
// 流量主ID搜素
export function validateUserId(rule, value, callback) {
  var re = /^[0-9]+$/
  if (!re.test(value) || value == '') {
    callback(new Error('只能输入整数'))
  } else {
    callback()
  }
}
// 不能为空
export function validateEmpty(value) {
  if (value == '') {
    return false
  } else {
    return true
  }
}
// qq号校验
export function validateQq(rule, value, callback) {
  var re = /^[0-9]+$/
  if (value == '' || value == null || value == undefined) {
    callback(new Error('QQ号码不能为空'))
  } else if (value.length < 5 || value.length > 15) {
    callback(new Error('QQ号码为5-15位'))
  } else if (!re.exec(value)) {
    callback(new Error('QQ号码格式不正确'))
  } else {
    callback()
  }
}
// 邮箱校验
export function validateEmail(rule, value, callback) {
  var re = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
  if (value == '') {
    callback(new Error('邮箱不能为空'))
  } else if (value.length < 6 || value.length > 32) {
    callback(new Error('请输入6-32位的邮箱'))
  } else if (!re.exec(value)) {
    callback(new Error('邮箱格式不正确'))
  } else {
    callback()
  }
}
// 广告链接地址验证
export function validateUrl(rule, value, callback) {
  var reg = /^(http|ftp|https):\/\/[\w]+(.[\w]+)([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#]).*/
  if (value == '') {
    callback(new Error('广告链接地址不能为空'))
  } else if (!reg.test(value)) {
    callback(new Error('地址格式不正确'))
  } else {
    callback()
  }
}
// 验证结束的pv不能小于开始的pv
export function comparePv(value, value1) {
  if (parseInt(value) > parseInt(value1)) {
    return false
  } else {
    return true
  }
}
// 验证参数名称  参数名满足：下划线，26个英文字母，0-9
export function v_parmasName(value) {
  var reg = /^\w{3,10}$/
  if (reg.test(value)) {
    return true
  } else {
    return false
  }
}
// 验证参数值  参数值满足：除单双引号以外的其他字符
export function v_parmasValue(value) {
  var reg = /^['|"]$/
  console.log(reg.test(value))
  if (reg.test(value)) {
    return false
  } else {
    return true
  }
}
// 验证长度不能超过20
export function validateTwenty(rule, value, callback) {
  if (value == '' || value == null || value == undefined) {
    callback(new Error('必填项不能为空'))
  } else if (value.length > 20) {
    callback(new Error('长度不能超过20'))
  } else {
    callback()
  }
}
// 验证下拉框必选
export function validateParent(rule, value, callback) {
  console.log(JSON.stringify(value))
  if (value == '' || value == null || value == undefined) {
    callback(new Error('必填项不能为空'))
  } else if (value.length > 20) {
    callback(new Error('长度不能超过20'))
  } else {
    callback()
  }
}
// 不能超过50
export function lengthFifty(rule, value, callback) {
  if (value == '' || value == null || value == undefined) {
    callback(new Error('必填项不能为空'))
  } else if (value.length > 50) {
    callback(new Error('长度不能超过50'))
  } else {
    callback()
  }
}
// 不能超过10
export function lengthTen(rule, value, callback) {
  if (value == '' || value == null || value == undefined) {
    callback(new Error('必填项不能为空'))
  } else if (value.length > 10) {
    callback(new Error('长度不能超过10'))
  } else {
    callback()
  }
}
// 纯数字不能超过11
export function validateNumber(rule, value, callback) {
  var re = /^[0-9]+$/
  if (value == '' || value == null || value == undefined) {
    callback(new Error('必填项不能为空'))
  } else if (value.length > 11) {
    callback(new Error('长度不能超过11'))
  } else if (!re.test(value)) {
    callback(new Error('请输入正确的手机号'))
  } else {
    callback()
  }
}
// 纯数字不能超过10
export function validateTenNumber(rule, value, callback) {
  var re = /^[0-9]+$/
  if (value == '' || value == null || value == undefined) {
    callback(new Error('必填项不能为空'))
  } else if (value.length > 10) {
    callback(new Error('长度不能超过10'))
  } else if (!re.test(value)) {
    callback(new Error('请输入纯数字'))
  } else {
    callback()
  }
}
// 收款账号
export function validateBankCode(rule, value, callback) {
  var re = /^[0-9]+$/
  if (value == '' || value == null || value == undefined) {
    callback(new Error('必填项不能为空'))
  } else if (value.length > 19 || value.length < 15) {
    callback(new Error('请输入15-19位的账号'))
  } else if (!re.test(value)) {
    callback(new Error('请输入正确的收款账号'))
  } else {
    callback()
  }
}
// 长度30
export function lengthThirty(rule, value, callback) {
  if (value == '' || value == null || value == undefined) {
    callback(new Error('必填项不能为空'))
  } else if (value.length > 30) {
    callback(new Error('长度不能超过30'))
  } else {
    callback()
  }
}
// 长度15位
export function lengthFifteen(rule, value, callback) {
  if (value == '' || value == null || value == undefined) {
    callback(new Error('必填项不能为空'))
  } else if (value.length > 15) {
    callback(new Error('长度不能超过15'))
  } else {
    callback()
  }
}
// 长度不超过500
export function validateFiveHundred(rule, value, callback) {
  if (value.length > 500) {
    callback(new Error('长度不能超过500'))
  } else {
    callback()
  }
}
// 长度不超过100
export function validateOneHundred(rule, value, callback) {
  if (value.length > 100) {
    callback(new Error('长度不能超过100'))
  } else {
    callback()
  }
}
// 身份证号码校验
export function validateCard(rule, value, callback) {
  var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  if (value == '' || value == null || value == undefined) {
    callback(new Error('必填项不能为空'))
  } else if (!reg.test(value)) {
    callback(new Error('请输入正确的身份证号'))
  } else {
    callback()
  }
}
// 校验父节点
export function validateParentId(rule, value, callback) {
  if (value == '' || value == null || value == undefined) {
    callback(new Error('必选项不能为空'))
  } else {
    callback()
  }
}
// 密码校验
export function validatePassword(rule, value, callback) {
  var re = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/
  if (value == '' || value == null || value == undefined) {
    callback( new Error('密码不能为空'))
  } else if (value.length < 6 || value.length > 20) {
    callback(new Error('请输入长度为6-20位的密码'))
  } else if (!re.exec(value)) {
    callback(new Error('请输入含有数字和字母的密码'))
  } else {
    callback()
  }
}
// 手机号校验
export function validateTelphone (rule, value, callback) {
  const myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/
  var reg = /^([0-9]{3,4}-)?[0-9]{7,8}$/
  if (value == '' || value == null || value == undefined) {
    callback(new Error('请输入手机号码'))
  } else if (value && value.length && !myreg.test(value) && !reg.test(value)) {
    callback(new Error('号码格式不对'))
  } else {
    callback()
  }
}